import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VclButtonModule, VclLinkModule, VclListModule, VclModalModule } from '@voxel/community';
import { LottieAnimationViewModule } from 'ng-lottie';

import { SharedComponentsModule } from '../../shared/components/shared-components.module';
import { GeneralInformationComponent } from '../shared/general-information/general-information.component';
import { ErrorComponent } from './error/error.component';
import { SharedRoutes } from './shared.routes';

const comunnityModules = [
  VclButtonModule,
  VclModalModule,
  VclLinkModule,
  VclListModule,
];

@NgModule({
  imports: [
    SharedRoutes,
    CommonModule,
    ...comunnityModules,
    SharedComponentsModule,
    LottieAnimationViewModule.forRoot(),
    SharedComponentsModule,
  ],
  providers: [],
  declarations: [
    ErrorComponent,
    GeneralInformationComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})

export class SharedModule { }
